import React from 'react'

import { StyledRootLayout } from './index.styles'

interface RootProps {
  children: React.ReactNode
}

const RootLayout = ({ children }: RootProps) => <StyledRootLayout data-testid="root-layout">{children}</StyledRootLayout>

export default RootLayout
